import React from 'react';
import { ReactComponent as IconFileCompress } from '../../../assets/svg/IconFileCompress.svg';
import { ReactComponent as IconFileExcel } from '../../../assets/svg/IconFileExcel.svg';
import { ReactComponent as IconFileImage } from '../../../assets/svg/IconFileImage.svg';
import { ReactComponent as IconFilePdf } from '../../../assets/svg/IconFilePdf.svg';
import { ReactComponent as IconFilePowerPoint } from '../../../assets/svg/IconFilePowerPoint.svg';
import { ReactComponent as IconFileVideo } from '../../../assets/svg/IconFileVideo.svg';
import { ReactComponent as IconFileWord } from '../../../assets/svg/IconFileWord.svg';
import { ReactComponent as IconFileText } from '../../../assets/svg/IconFileText.svg';
import { ReactComponent as IconFileSound } from '../../../assets/svg/IconFileSound.svg';
import { ReactComponent as IconFileExe } from '../../../assets/svg/IconFileExe.svg';
import { ReactComponent as IconFileDmg } from '../../../assets/svg/IconFileDmg.svg';
import { ReactComponent as IconFileDeb } from '../../../assets/svg/IconFileDeb.svg';
import { TYPE_FILES } from 'constants/files';

const MapIconFile = ({ type }) => {
    switch (type) {
        case TYPE_FILES.COMPRESS:
            return <IconFileCompress className="icon-type-file" />;
        case TYPE_FILES.EXCEL:
            return <IconFileExcel className="icon-type-file" />;
        case TYPE_FILES.IMAGE:
            return <IconFileImage className="icon-type-file" />;
        case TYPE_FILES.PDF:
            return <IconFilePdf className="icon-type-file" />;
        case TYPE_FILES.POWERPOINT:
            return <IconFilePowerPoint className="icon-type-file" />;
        case TYPE_FILES.VIDEO:
            return <IconFileVideo className="icon-type-file" />;
        case TYPE_FILES.WORD:
            return <IconFileWord className="icon-type-file" />;
        case TYPE_FILES.TEXT:
            return <IconFileText className="icon-type-file" />;
        case TYPE_FILES.SOUND:
            return <IconFileSound className="icon-type-file" />;
        case TYPE_FILES.EXE:
            return <IconFileExe className="icon-type-file" />;
        case TYPE_FILES.DMG:
            return <IconFileDmg className="icon-type-file" />;
        case TYPE_FILES.DEB:
            return <IconFileDeb className="icon-type-file" />;
        default:
            return <IconFileCompress className="icon-type-file" />;
    }
};

export default MapIconFile;
